/** Chart options for Apex Charts */
export const chartOptions = {
  chart: {
    type: 'line',
    height: 495,
    toolbar: { show: false },
    animations: { enabled: false },
    zoom: { enabled: false },
  },
  stroke: { curve: 'smooth', width: [3, 3] },
  colors: ['#ffffff'],
  markers: { show: false },
  xaxis: {
    show: false,
    axisBorder: {
      show: false,
    },
    labels: {
      show: false,
    },
    axisTicks: {
      show: true, // Needs to be true to render the ticks as part of the graph line display logic. The lines are transparent from below option.
      color: 'transparent',
    },
  },
  yaxis: {
    show: false,
    min: 0,
    max: 100,
  },
  grid: {
    show: false,
    padding: {
      left: 0,
      right: 0,
    },
  },
  tooltip: { enabled: false },
  legend: { show: false, position: 'top' },
}
